<template>
  <div>
    <div class="top">
      <div class="text">
        <div class="title">
          In-Depth Interview (IDI)
        </div>
        <div class="value">
          In depth interviews (IDI) are conducted on a 1-on-1 bases. Participants in an IDI have more time to speak and react to questions and that helps acquire a deeper insight into the research subject.
          </br>

          An in-depth interview also allows the interviewer to give the participant full attention and our consultant can also adjust the interviewing style in order to get the most out of the interview.

        </div>
        <div><button @click="contact">REQUEST A BID</button></div>
      </div>
    </div>

    <div class="recommended">
      <div class="title">
        IDI is recommended when:
      </div>
      <div class="value">
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/interview/interview1.png">
          <div class="text">
            Working with small target populations
          </div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/interview/interview2.png">
          <div class="text">
            Geographically-dispersed study area

          </div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/interview/interview3.png">
          <div class="text">
            Deep layers of information from probing are required

          </div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/interview/interview4.png">
          <div class="text">
            Require a quick, easy to manage general understanding of the market

          </div>
        </div>
      </div>
    </div>

    <!-- 卡片 -->
    <div class="cardtitle">
      IDI conducted in
    </div>
    <el-carousel :interval="4000" type="card" :autoplay="false" indicator-position="none">
      <el-carousel-item>
        <div class="medium">
          <div class="year">
            2021
          </div>
          <div class="value">
            <div class="hcp">
              1069 Asia HCPs
            </div>
            <div class="patients">
              209 Asia patients
            </div>
            <div class="consumer">
              1008 Asia consumers
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="medium">
          <div class="year">
            2022
          </div>
          <div class="value">
            <div class="hcp">
              1071 Asia HCPs
            </div>
            <div class="patients">
              91 Asia patients
            </div>
            <div class="consumer">
              625 Asia consumers
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="medium">
          <div class="year">
            2020
          </div>
          <div class="value">
            <div class="hcp">
              981 Asia HCPs
            </div>
            <div class="patients">
              127 Asia patients
            </div>
            <div class="consumer">
              725 Asia consumers
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>

    <div class="Consultants">
      <div class="title">
        Strengths of our Qualitative research consultants

      </div>
      <div class="value">
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/interview/interview5.png">
          <div class="text">
            Local Expertise
          </div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/interview/interview6.png">
          <div class="text">
            Industry Knowledge
          </div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/interview/interview7.png">
          <div class="text">
            Trained & Experienced
          </div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/interview/interview8.png">
          <div class="text">
            Transcription/Summary to Reporting
          </div>
        </div>
      </div>
    </div>

    <case-study />
  </div>
</template>

<script>
import CaseStudy from "@/components/caseStudy";
import { advertisementFlow } from "@/api/api";

export default {
  data() {
    return {};
  },
  components: {
    CaseStudy
  },
  created() {
    this.loading();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
  },
  methods: {
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "interview",
          source: "",
          information: "Solutions_interview"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "interview",
          source: this.$route.query.source,
          information: "Solutions_interview"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    contact() {
      let routeData = this.$router.resolve({ path: "/contact?source=bid" });
      window.open(routeData.href, "_blank");
    },
    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    }
  }
};
</script>

<style lang="scss" scoped>
.top {
  padding: 90px 200px;
  // height: 600px;
  background-image: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/interview/interviewbg.png");
  background-size: cover;
  .text {
    color: #fff;
    width: 60%;
    .title {
      width: 70%;
      font-size: 50px;
      font-weight: 700;
      margin-bottom: 25px;
    }
    .value {
      font-size: 20px;
    }
    button {
      border: none;
      background-color: #2cb1e9;
      color: #fff;
      font-size: 20px;
      border-radius: 10px;
      margin-top: 20px;
      padding: 10px;
    }
  }
}
.recommended,
.Consultants {
  padding: 120px;
  text-align: center;
  .title {
    font-size: 40px;
    font-weight: 700;
    padding-bottom: 60px;
  }
  .value {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    // padding: 50px;
    .box {
      width: 20.5%;
      img {
        width: 100px;
        margin-bottom: 30px;
      }
      .text {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 20px;
      }
    }
  }
}
.cardtitle {
  color: #2cb1e9;
  padding: 80px 120px 30px 120px;
  text-align: center;
  font-weight: 700;
  font-size: 45px;
}
@media screen and (max-width: 576px) {
  .top {
    padding: 90px 100px;
    .text {
      width: 100%;
      .title {
        width: 80%;
        font-size: 110px;
      }
      .value {
        font-size: 70px;
      }
      button {
        font-size: 70px;
        padding: 20px;
      }
    }
  }
  .recommended,
  .Consultants {
    .title {
      font-size: 80px;
      margin-bottom: 100px;
    }
    .value {
      .box {
        width: 90%;
        img {
          width: 400px;
        }
        .text {
          font-size: 70px;
          margin-bottom: 150px;
        }
      }
    }
  }
  .cardtitle {
    font-size: 80px;
  }
}
</style>
<style lang="scss">
.el-carousel__container {
  margin-bottom: 60px;
  height: 350px;
}
.el-carousel__item {
  .medium {
    padding: 50px;
    text-align: center;
    font-size: 35px;
    font-weight: 700;
    color: #fff;
    .year {
      font-size: 40px;
      margin-bottom: 60px;
    }
  }
  .el-carousel__mask {
    opacity: 0.4;
  }
}

.el-carousel__item:nth-child(2n) {
  background-color: #2cb1e9;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #2cb1e9;
}

@media screen and (max-width: 576px) {
  .el-carousel__item {
    width: 60%;
    .medium {
      font-size: 65px;
      .year {
        font-size: 80px;
      }
    }
  }
  .el-carousel {
    // height: 600px;
    .el-carousel__container {
      height: 600px !important;
      .el-carousel__arrow {
        width: 100px;
        height: 100px;
        i {
          font-size: 40px;
        }
      }
    }
  }
}
</style>